module.exports = __webpack_public_path__ + "img/乌镇人民公园.e0be70d4.jpg";